import {
  BodyOrientationType,
  GRADIENT_TYPES,
} from 'queries/details/usePlaybackDetailsQuery';

import styled from 'styled-components/macro';

export const StyledLink = styled.a`
  text-decoration: none;
  color: inherit;
  display: inline-flex;
  align-items: center;

  &:hover {
    text-decoration: underline;
  }
`;

export const LandingPageContentContainer = styled.div<{
  bodyBackgroundImage?: string;
  backgroundColor?: string;
  showGradient?: number;
  gradient?: GRADIENT_TYPES;
  bodyOrientation?: BodyOrientationType;
}>`
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  flex: 1;
  gap: 32px;
  padding: 32px;

  background-color: ${props => props.backgroundColor};
  background-size: cover;
  background-position: ${({ bodyOrientation }) =>
    bodyOrientation === 'left'
      ? 'right'
      : bodyOrientation === 'right'
        ? 'left'
        : 'center'};
  background-repeat: no-repeat;
  background-image: ${({ bodyBackgroundImage, showGradient, gradient }) => {
    if (bodyBackgroundImage) {
      const gradientOverlay =
        showGradient && gradient
          ? gradient === GRADIENT_TYPES.DARK
            ? 'linear-gradient(89.91deg, rgba(0, 0, 0, 0.4) 0.09%, rgba(0, 0, 0, 0) 99.92%), '
            : 'linear-gradient(45deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.1)), '
          : '';
      return `${gradientOverlay}url(${bodyBackgroundImage})`;
    }
    return 'none';
  }};

  @media screen and (max-width: 1034px) {
    gap: 20px;
  }

  @media screen and (max-width: 820px) {
    padding: 16px;
  }
`;

export const FooterContainer = styled.div<{
  footerBackgroundColor?: string;
  showFooterShadow: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 8px 16px;
  box-sizing: border-box;
  min-height: 120px;
  background: ${({ footerBackgroundColor }) => footerBackgroundColor || '#FFF'};

  position: relative;
  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 6px;
    pointer-events: none;
    background: transparent;
    box-shadow: ${({ showFooterShadow }) =>
      showFooterShadow ? '0 -2px 4px -1px rgba(0, 0, 0, 0.12)' : 'none'};
  }
`;
